


export interface UndeliveredParams {
	dateFrom: string,
	dateTo: string,
	customerId?: string,
	dc?: string,
	materialId?: string,
	region?: string,
	district?: string,
	phase?: string,
}



export enum UndeliveredPhase {
	both = 'BOTH',
	plan = 'PLAN',
	execution = 'EXECUTION',
	unknown = 'UNKNOWN',
}